import React from "react"
import PropTypes from "prop-types"
import LexicoinHistory from './LexicoinHistory'

class UserGamificationDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lexicoins: this.props.currentUser.lexicoins,
      historyOpen: false
    }

    this.toggleHistory = this.toggleHistory.bind(this)
  }

  toggleHistory() {
    this.setState({
      historyOpen: !this.state.historyOpen
    })
  }

  render() {
    return(
      <div className="gamificationSection">
        <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%', alignItems: 'center'}}>
          <div style={{display: 'flex', alignItems: 'center', marginRight: 20, cursor: 'pointer'}}>
            <img src={this.props.currentUser.avatar_url != 'medium/missing.png' ? this.props.currentUser.avatar_url : this.props.missingImg}
              style={{height: 40, width: 40, borderRadius: 20}}
              onClick={() => window.location.assign(`/profile/${this.props.currentUser.slug}`)}
            />
          </div>
          <div style={{float: 'right', display: 'flex', flexDirection: 'column' , cursor: 'pointer'}} onClick={() => this.toggleHistory()}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 6}}>
              <div className="lexicoinHistoryTeaser"></div>
              <h5 style={{width: 30, marginLeft: -35, color: '#fff', textAlign: 'center', fontWeight: 'bold'}}>{this.state.lexicoins}</h5>
            </div>
          </div>
        </div>
        {this.state.historyOpen &&
          <LexicoinHistory
            onClose={this.toggleHistory}
            lexicoins={this.state.lexicoins}
          />
        }
      </div>
    )
  }

}

export default UserGamificationDashboard;
